import { DataSyncRun } from '../../../utils/dataSyncApi';

interface SyncProgressBarProps {
  run: DataSyncRun | null;
}

export function SyncProgressBar({ run }: SyncProgressBarProps) {
  if (!run) return null;

  const total = run.total || 0;
  const processed = run.processed || 0;
  const pct = total > 0 ? Math.min(100, Math.round((processed / total) * 100)) : 0;
  const isActive = run.status === 'pending' || run.status === 'running';
  const isFailed = run.status === 'failed';
  const isDone = run.status === 'completed';

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 space-y-3">
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium text-menioo-navy">
          {isActive && 'Sync en cours…'}
          {isDone && 'Sync terminée'}
          {isFailed && 'Sync échouée'}
        </span>
        <span className="text-gray-500">
          {processed} / {total} ({pct}%)
        </span>
      </div>

      <div className="h-2 w-full overflow-hidden rounded-full bg-gray-100">
        <div
          className={`h-full transition-all duration-300 ${
            isFailed ? 'bg-red-500' : isDone ? 'bg-menioo-green' : 'bg-menioo-green/80'
          }`}
          style={{ width: `${isActive && pct === 0 ? 4 : pct}%` }}
        />
      </div>

      {run.currentLabel && (
        <p className="text-xs text-gray-500 truncate">{run.currentLabel}</p>
      )}

      {(isDone || isFailed) && (
        <div className="flex flex-wrap gap-3 text-xs text-gray-600">
          <span>Créés : {run.copied}</span>
          <span>Écrasés : {run.overwritten}</span>
          <span>Échecs : {run.failed}</span>
        </div>
      )}

      {run.errors?.length > 0 && (
        <ul className="max-h-32 overflow-y-auto text-xs text-red-600 space-y-1">
          {run.errors.slice(0, 20).map((e, i) => (
            <li key={i}>
              {e.collection ? `[${e.collection}] ` : ''}
              {e.id ? `${e.id}: ` : ''}
              {e.error}
            </li>
          ))}
          {run.errors.length > 20 && (
            <li>… et {run.errors.length - 20} autres</li>
          )}
        </ul>
      )}
    </div>
  );
}
